module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-BookItalic-78306396e4dc874fb1955f13ea5ecf36.woff2";